const StripePK = process.env.REACT_APP_STRIPE_PK!;

export async function redirectToCheckout(sessionId: string) {
  const stripe = Stripe(StripePK);
  return await stripe.redirectToCheckout({
    sessionId
  });
}
